import { useCallback, useMemo } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from '@material-ui/core'
import { Close, PostAdd } from '@mui/icons-material'
import { NPS_ACCEPTED_FILES } from '../../../../constants'
import { UploadedFile } from 'models/general'
import FileUploader from 'components/FormComponents/FileUploader/FileUploader'
import './styles.scss'

interface IManagementAccountantsNPSButtonProps {
  isLoading: boolean
  isOpen: boolean
  handleSubmit: (file: UploadedFile) => void
  setFile: (file?: UploadedFile) => void
  setIsOpen: (v: boolean) => void
  file?: UploadedFile
}

const ManagementAccountantsNPSButton = ({
  isLoading,
  isOpen,
  file,
  handleSubmit,
  setFile,
  setIsOpen,
}: IManagementAccountantsNPSButtonProps) => {
  const handleFile = (files: UploadedFile[]) => {
    const file = files[0]
    setFile(file)
  }

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleOpen = () => {
    handleToggle()
  }

  const handleRemove = () => setFile(undefined)

  const handleFileUpload = useCallback(() => {
    file !== undefined && handleSubmit(file)
  }, [handleSubmit, file])

  const dropzoneLabel = useMemo(() => {
    if (file && !isLoading) return `${file.name}.${file.extension}`
    if (file && isLoading) return `Cargando ${file.name}.${file.extension}`
    return 'Subir archivo NPS.xlsx'
  }, [file, isLoading])

  return (
    <div className="management-accountants-nps-button">
      <Button className="button" size="large" onClick={handleOpen}>
        <PostAdd fontSize="large" />
        <Typography className="text">
          Actualizar información del contador
        </Typography>
      </Button>
      <Dialog
        open={isOpen}
        className="dialog"
        fullWidth
        maxWidth="sm"
        keepMounted
        PaperComponent={({ children }) => (
          <Box className="dialog-paper">{children}</Box>
        )}>
        <Box className="close">
          <IconButton
            onClick={() => {
              handleRemove()
              handleToggle()
            }}
            disabled={isLoading}>
            <Close />
          </IconButton>
        </Box>
        <DialogContent className="dialog-content">
          <Box className="title">Sube el NPS</Box>
          <Box className="subtitle">
            Sube tu archivo NPS en formato XLSX para que se autocomplete la
            información de manera automática.
          </Box>
          <Box className="dropzone-parent">
            <FileUploader
              label={dropzoneLabel}
              onValue={handleFile}
              accept={NPS_ACCEPTED_FILES}
              limit={1}
              color="secondary"
              className="dropzone"
              disabled={file !== undefined}
              loading={isLoading}
            />
          </Box>
        </DialogContent>
        <DialogActions className="actions">
          {file !== undefined ? (
            <Button
              className="button cancel"
              onClick={handleRemove}
              disabled={isLoading}>
              Remover
            </Button>
          ) : (
            <Button
              className="button cancel"
              onClick={handleToggle}
              disabled={isLoading}>
              Cancelar
            </Button>
          )}
          <Button
            className="button primary"
            disabled={file === undefined || isLoading}
            onClick={handleFileUpload}>
            Subir
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ManagementAccountantsNPSButton
